import React, {useEffect, useState} from "react";
import AuthenticationService from "../../../services/Authentication/AuthenticationService";
import {connect} from "react-redux";

function ContactForm(props){

    const [fullName,setFullName]= useState('');
    const [email,setEmail]=useState('');
    const [subject,setSubject]= useState('');
    const [text, setText] = useState('');

    const [isNameValid,setNameValid] = useState(false);
    const [isEmailValid,setEmailValid] = useState(false);
    const [isSubjectValid,setSubjectValid] = useState(false);
    const [isTextValid,setTextValid] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');


    function sendEmail(event) {

        event.preventDefault();

        if(!isTextValid || !isEmailValid || !isNameValid || !isSubjectValid){
            setErrorMessage('Please complete all fields');
            return;
        }

        props.emailSentHandler();
        let payload = {
            firstName: fullName,
            email: email,
            subject: subject,
            content: text
        };
        AuthenticationService.sendContactEmail(payload,
            (success)=>{
            }),
            (err) =>{
            console.log(err)
            }
    }


    useEffect(()=>{
        fillUserEmail()
    },[]);

    function fillUserEmail(){
        if(document.cookie.includes("globals_bubbly")){
            let cookie = document.cookie.split("globals_bubbly")[1].split("}")[0];
            let userId = cookie.split("userId%22:")[1].split("%")[0];
            if(userId.length > 0){
                AuthenticationService.getUserEmail(userId,
                    (success) => {
                        setEmailValid(true);
                        setNameValid(true);
                        setEmail(success.data.email);
                        setFullName(success.data.name);
                    },
                    (error) => {
                        console.log(error);
                    })
            }
        }
    }


    function handleNameChange(event){
        if(event.target.value.length>0)
            setNameValid(true);
        else
            setNameValid(false);

        setFullName(event.target.value);
    }

    function handleSubjectChange(event){
        if(event.target.value.length > 0)
            setSubjectValid(true);
        else
            setSubjectValid(false);

        setSubject(event.target.value);

    }

    function handleEmailChange(event){
        setEmail(event.target.value);
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if(re.test(String(event.target.value).toLowerCase()))
            setEmailValid(true);
        else
            setEmailValid(false);

    }

    function handleTextChange(event){
        if(event.target.value.length > 0)
            setTextValid(true);
        else
            setTextValid(false);

        setText(event.target.value);
    }

    return <React.Fragment>
        <form onSubmit={sendEmail} className="form">
            <div className="contact__section__title">Questions, suggestions or improvements? Write them below:</div>
            <div className="form__group pt-md">
                <div className="form__group__input">
                    {
                        !props.isUserLoggedIn ?
                            <input className={"form__group__input__text form__group__input__text--noIcon " + ((!isNameValid && errorMessage.length > 0) ? "error_border_contact" : "")}
                                   type="text" placeholder="Full Name" value={fullName} onChange={handleNameChange}/>:
                            <input className={"form__group__input__text form__group__input__text--noIcon "}
                                   type="text" placeholder="Full Name" value={fullName} readOnly/>
                    }


                </div>
            </div>
            <div className="form__group">
                <div className="form__group__input">
                    {
                        !props.isUserLoggedIn ?
                            <input className={"form__group__input__text form__group__input__text--noIcon " + ((!isEmailValid && errorMessage.length > 0) ? "error_border_contact" : "")}
                                   type="email" placeholder="E-Mail" value={email} onChange={handleEmailChange}/> :
                            <input className={"form__group__input__text form__group__input__text--noIcon"}
                                   type="email" placeholder="E-Mail" value={email} readOnly/>
                    }
                    <div className="error_text_contact">
                        { email.length > 0 ?  (isEmailValid ? "" : "Please insert a valid email address."):"" }</div>

                </div>
            </div>
            <div className="form__group">
                <div className="form__group__input">
                    <input className={"form__group__input__text form__group__input__text--noIcon " + ((!isSubjectValid && errorMessage.length > 0) ? "error_border_contact" : "")}
                           type="text" placeholder="Subject" value={subject} onChange={handleSubjectChange}/>
                </div>
            </div>
            <div className="form__group">
                <div className="form__group__input">
                                    <textarea className={"form__group__input__textarea " + ((!isTextValid && errorMessage.length > 0) ? "form__group__input__text--noIcon error_border_contact" : "")} cols="30" rows="5"
                                              placeholder="Write Your Message Here..." value={text}
                                    onChange={handleTextChange}></textarea>
                </div>
            </div>
            <div className="form__group">
                <div className="error_text_contact">
                    {errorMessage}
                </div>
            </div>
            <div className="cta__wrapp cta__wrapp--left pt-xs">
                <button type="submit" className="cta--normal cta--fullwidth cta--notransform">Send</button>
            </div>
        </form>

    </React.Fragment>

}

function mapStateToProps(state) {
    return {
        isUserLoggedIn: state.user.loggedIn
    };
}

export default connect(mapStateToProps)(ContactForm);